import Accordion from 'accordion-js';
import {getElement, getElements} from "./utils/utils";


const initAccordions = () => {
    const accodionsGroup = getElements('.js-accordions')

    if (accodionsGroup) {
        accodionsGroup.map(accordions => {
            new Accordion(accordions, {
                duration: 400,
            });
        })

        if (getElement('.js-accordions-support')) {
            getElements('.js-accordions').map(accordions => {
                accordions.querySelector('.ac .ac-header').click()
            })
        }
    }
}

export {initAccordions}
